import { InsuranceCarrier } from '@shared/insuranceCarrierDefs';

// Currently no feature flags for carriers. All carriers are enabled.
const CARRIER_FEATURE_FLAG_MAP: Partial<Record<InsuranceCarrier, FeatureFlagKeys | null>> = {
  [InsuranceCarrier.CareScout]: 'quoteApplyCareScout',
  [InsuranceCarrier.LincolnFinancial]: 'quoteApplyLincolnFinancial',
  [InsuranceCarrier.SecurianFinancial]: 'quoteApplySecurianFinancial',
};

export function getCarrierFeatureFlag(carrierId: InsuranceCarrier): FeatureFlagKeys | null {
  return CARRIER_FEATURE_FLAG_MAP[carrierId] || null;
}

export function calculateEnabledCarrierIds(featureFlags?: FeatureFlags): number[] {
  const enabledCarriers: number[] = [];

  for (const [carrierId, featureFlagKey] of Object.entries(CARRIER_FEATURE_FLAG_MAP)) {
    const carrierIdNum = Number(carrierId);

    if (featureFlagKey === null) {
      enabledCarriers.push(carrierIdNum);
    } else if (featureFlags?.[featureFlagKey]) {
      enabledCarriers.push(carrierIdNum);
    }
  }

  return enabledCarriers;
}
